mutation AddCompetitor(
  $boardId: ID!
  $name: String!
  $score: Int
  $nameTextColor: String!
  $scoreTextColor: String!
  $imageUrl: String
  $scoreImageUrl: String
) {
  competitor: StreamToolsAddCompetitor(
    boardId: $boardId
    name: $name
    score: $score
    nameTextColor: $nameTextColor
    scoreTextColor: $scoreTextColor
    imageUrl: $imageUrl
    scoreImageUrl: $scoreImageUrl
  ) {
    competitorId
    boardId
    name
    score
    nameTextColor
    scoreTextColor
    imageUrl
    scoreImageUrl
  }
}
